var _defs, _path, _rect, _path2, _path3, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToughEnoughToCareLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28928",
    "data-name": "Group 28928",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152.119,
    height: 26.84,
    viewBox: "0 0 152.119 26.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4688",
    "data-name": "Rectangle 4688",
    width: 152.119,
    height: 26.84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140277",
    "data-name": "Path 140277",
    d: "M6.557,18.225v.534H141.7v-.6Z",
    transform: "translate(-6.557 -18.161)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4679",
    "data-name": "Rectangle 4679",
    width: 135.141,
    height: 0.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 105 1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 105,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAAABCAYAAADdJYANAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAaaADAAQAAAABAAAAAQAAAABPH6dUAAAAEklEQVQYGWP8//8/wygY3CEAAOedAv8RNifnAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4683",
    "data-name": "Rectangle 4683",
    width: 135.141,
    height: 0.044,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4682",
    "data-name": "Rectangle 4682",
    width: 135.141,
    height: 0.045,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140278",
    "data-name": "Path 140278",
    d: "M5.561,22.619H141.995v-.594H5.561Zm0-19.384H141.995v-.29H5.561Z",
    transform: "translate(-5.561 -2.946)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4686",
    "data-name": "Rectangle 4686",
    width: 136.435,
    height: 19.673,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-3",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 106 16"
  }, /*#__PURE__*/React.createElement("image", {
    width: 106,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAAQCAYAAAD+mOowAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAaqADAAQAAAABAAAAEAAAAABBBULiAAAAnElEQVRYCe2ZwQ2AIBAE7wQLsRdLMKE1HxaqoqJLCcQHm+yRmPiATHbcD3opxbZ1m03TdQIOUZr+Exj6RxQhEpAoku9AoiSKJAESTDVKokgSIMFUoySKJAESTDVKokgSIMFUoySKJAESTDWKRFQEZ1rS1Mz7Xb6f+bL7KYaF8W/FMFiMwdybT/5lI34O7EeuZ4EPbJhxDJWxvhA8XimHGVKQnNbcAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28927",
    "data-name": "Group 28927",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140273",
    "data-name": "Path 140273",
    d: "M6.708,2.941,3.119,6.38,2.9,18.909l4.754,3.712,136.017-.482,3.589-3.438V6.38l-3.806-3.231Z",
    transform: "translate(0.868 0.88)",
    fill: "#0b0c0c"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4675",
    "data-name": "Rectangle 4675",
    width: 137.905,
    height: 2.205,
    transform: "translate(7.107 0.846)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140274",
    "data-name": "Path 140274",
    d: "M6.178.589H145.939l.45.43,4.666,4.471.448.431v15l-.448.43-4.666,4.472-.45.43H6.178l-.448-.43L1.063,21.349l-.45-.43v-15l.45-.431L5.73,1.019ZM5.925,0,5.3.6.629,5.074,0,5.676V21.162l.629.6L5.3,26.237l.629.6H146.193l.63-.6,4.666-4.471.63-.6V5.676l-.63-.6L146.823.6l-.63-.6Z",
    fill: "#0b0c0c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140275",
    "data-name": "Path 140275",
    d: "M6.461,1.719,6.027,1.3,1.181,5.947v14.27l5.026,4.816h139l5.027-4.816V5.947L145.2,1.131h-139L6.027,1.3l.434.416v.589H144.7L149,6.434V19.728L144.7,23.856H6.715L2.408,19.728V6.434l4.486-4.3-.434-.416v0Z",
    transform: "translate(0.353 0.338)",
    fill: "#0b0c0c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28903",
    "data-name": "Group 28903",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28902",
    "data-name": "Group 28902",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140276",
    "data-name": "Path 140276",
    d: "M6.728,3.009,6.511,2.8,2.923,6.24l-.09.086V18.889l.09.087,3.589,3.438.09.087h137.22l.09-.087,3.59-3.438.09-.087V6.326l-.09-.086L143.91,2.8l-.09-.086H6.6l-.09.086.217.208V3.3H143.693V3.009l-.217.208,3.589,3.439.217-.208h-.307V18.769h.307l-.217-.209Q145.272,20.28,143.477,22l.217.208v-.294H6.728v.294L6.945,22,3.357,18.559l-.217.209h.307V6.448H3.14l.217.208L6.945,3.217l-.217-.208v0Z",
    transform: "translate(0.848 0.812)",
    fill: "#0b0c0c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28910",
    "data-name": "Group 28910",
    transform: "translate(8.519 23.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28909",
    "data-name": "Group 28909",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28908",
    "data-name": "Group 28908",
    transform: "translate(0 -0.001)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28907",
    "data-name": "Group 28907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28906",
    "data-name": "Group 28906",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28905",
    "data-name": "Group 28905",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28904",
    "data-name": "Group 28904",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4677",
    "data-name": "Rectangle 4677",
    width: 125.621,
    height: 0.599,
    fill: "url(#pattern)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28917",
    "data-name": "Group 28917",
    transform: "translate(8.519 24.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28916",
    "data-name": "Group 28916",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28915",
    "data-name": "Group 28915",
    transform: "translate(0 0)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28914",
    "data-name": "Group 28914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28913",
    "data-name": "Group 28913",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28912",
    "data-name": "Group 28912",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28911",
    "data-name": "Group 28911",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4680",
    "data-name": "Rectangle 4680",
    width: 70.152,
    height: 0.045,
    fill: "url(#pattern)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28924",
    "data-name": "Group 28924",
    transform: "translate(7.225 3.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28923",
    "data-name": "Group 28923",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28922",
    "data-name": "Group 28922",
    transform: "translate(0 -0.001)",
    style: {
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28921",
    "data-name": "Group 28921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28920",
    "data-name": "Group 28920",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28919",
    "data-name": "Group 28919",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28918",
    "data-name": "Group 28918",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4684",
    "data-name": "Rectangle 4684",
    width: 130.483,
    height: 19.673,
    fill: "url(#pattern-3)"
  }))))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28926",
    "data-name": "Group 28926",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28925",
    "data-name": "Group 28925",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140279",
    "data-name": "Path 140279",
    d: "M8.753,4.8A2.081,2.081,0,0,0,8.1,6.2h2.756l.03.029Q8.846,15.29,8.575,16.7q0,.918,1.143,1.065l.509-.03L12.142,9.16A29.014,29.014,0,0,1,12.828,6.2h1.443a1.526,1.526,0,0,0,1.134-.518,2.457,2.457,0,0,0,.447-1.206h-.03L15.8,4.45H9.656a1.539,1.539,0,0,0-.9.347m6.14,4.252a3.953,3.953,0,0,0-1.79,2.2,34.146,34.146,0,0,0-.819,3.963,2.822,2.822,0,0,0,.325,1.324,2.534,2.534,0,0,0,2.284,1.236h.88a3.865,3.865,0,0,0,2.47-.9,4.419,4.419,0,0,0,1.2-1.715,29.875,29.875,0,0,0,.85-4.134,3.507,3.507,0,0,0-.147-.864,2.629,2.629,0,0,0-2.732-1.634l-.231.03-.208-.03a4.544,4.544,0,0,0-2.084.533m-.672,5.6a15.26,15.26,0,0,1,.911-3.542,1.922,1.922,0,0,1,1.79-.813h.2q1.3,0,1.3.754v.17A26.328,26.328,0,0,1,17.8,14.2a1.921,1.921,0,0,1-2,1.827h-.5q-1.15,0-1.149-.873c0-.335.019-.5.061-.5M22.137,8.5l-.409,1.773q-1,4.422-1,4.837v.221a2.793,2.793,0,0,0,.239,1.1,2.838,2.838,0,0,0,2.8,1.332h.178a4.167,4.167,0,0,0,1.975-.422h.023a1.3,1.3,0,0,0,1,.422H27.3l.03-.03q1.59-7.092,1.767-8.111V9.574q0-.969-1.119-1.072h-.439l-1.451,6.351a2.2,2.2,0,0,1-2.269,1.162q-1.236,0-1.236-.932l1.15-5.457-.03-.282A1.065,1.065,0,0,0,22.523,8.5Zm7.807,2.38a26.081,26.081,0,0,0-.819,3.846v.325a2.892,2.892,0,0,0,.139.843q.555,1.524,2.917,1.523a4.42,4.42,0,0,0,1.475-.273h.023l.03.029-.277,1a1.962,1.962,0,0,1-2.045,1.08H29.241a1.7,1.7,0,0,0-1.2.577,2.87,2.87,0,0,0-.362,1.078h.03l.031.03h3.867a4.355,4.355,0,0,0,1.706-.437,3.685,3.685,0,0,0,1.8-1.893q.177-.5,2.27-10.034c0-.053-.2-.081-.6-.081a1.541,1.541,0,0,0-1.049.407h-.023a3.936,3.936,0,0,0-2.045-.407,3.8,3.8,0,0,0-3.735,2.388m1.528,1.028A1.938,1.938,0,0,1,33.6,10.18a4.168,4.168,0,0,1,.787.074.763.763,0,0,1,.625.813q0,.259-.656,3.121A1.85,1.85,0,0,1,32.522,15.7h-.486q-1.15,0-1.15-.865.045-.518.586-2.929m8.085-7.46L36.9,16.51v.17q.131,1.087,1.073,1.087h.478l.031-.03.9-4.008q.5-2.6.956-2.951.4-.628,1.883-.628,1.29,0,1.289.946-.06.585-1.134,5.354v.229q.125,1.087,1.073,1.087h.509l.717-3.239a26.1,26.1,0,0,0,.718-3.55v-.14a3.372,3.372,0,0,0-.147-.917q-.587-1.545-3.11-1.545H42.1a4.283,4.283,0,0,0-1.55.251l-.031-.022L41.171,5.6l-.062-.37a1.1,1.1,0,0,0-1.165-.776Zm10.64.14a4.055,4.055,0,0,0-2.239,1.634,4.967,4.967,0,0,0-.717,2.033q-1.466,6.262-1.466,6.928a2.678,2.678,0,0,0,.331,1.346,2.763,2.763,0,0,0,2.447,1.236h3.857c.073,0,.131-.23.178-.689l-.061-.369a1.232,1.232,0,0,0-1.281-.717H48.916q-1.259,0-1.258-.917a30.483,30.483,0,0,1,.625-3.091h4.545c.068,0,.126-.212.178-.635l-.084-.481a1.2,1.2,0,0,0-1.228-.665H48.677l.594-2.574a1.951,1.951,0,0,1,2.061-1.4h3.65c.073,0,.131-.21.178-.629q0-1.146-1.582-1.146H51.694a6.3,6.3,0,0,0-1.5.14M55.49,8.605q-1.7,7.579-1.76,8.067v.142l.062.251a1.223,1.223,0,0,0,1.258.7h.231l.031-.03L56.663,11.7a1.951,1.951,0,0,1,2-1.434,3.035,3.035,0,0,1,1.142.17.658.658,0,0,1,.409.673l-.031.391L59.1,16.584v.23l.055.251a1.248,1.248,0,0,0,1.265.7h.2a5.267,5.267,0,0,0,.355-1.376A51.411,51.411,0,0,0,62.1,10.964a3,3,0,0,0-.178-.984,2.53,2.53,0,0,0-2.439-1.434h-.909a3.574,3.574,0,0,0-1.614.361,1.217,1.217,0,0,0-.848-.361h-.231a.984.984,0,0,0-.386.058m9.666.444a3.953,3.953,0,0,0-1.79,2.2,34.147,34.147,0,0,0-.819,3.963,2.807,2.807,0,0,0,.325,1.324,2.534,2.534,0,0,0,2.284,1.236h.88a3.868,3.868,0,0,0,2.47-.9,4.419,4.419,0,0,0,1.2-1.715,29.875,29.875,0,0,0,.85-4.134,3.508,3.508,0,0,0-.147-.864A2.629,2.629,0,0,0,67.68,8.517l-.231.03-.208-.03a4.544,4.544,0,0,0-2.084.533m-.672,5.6A15.259,15.259,0,0,1,65.4,11.1a1.922,1.922,0,0,1,1.79-.813h.2q1.3,0,1.3.754v.17a26.327,26.327,0,0,1-.617,2.981,1.921,1.921,0,0,1-2,1.827h-.494q-1.15,0-1.15-.873c0-.335.019-.5.061-.5M72.4,8.5l-.409,1.773q-1,4.422-1,4.837v.221a2.793,2.793,0,0,0,.239,1.1,2.838,2.838,0,0,0,2.8,1.332h.178a4.164,4.164,0,0,0,1.975-.422H76.2a1.294,1.294,0,0,0,1,.422h.356l.03-.03q1.59-7.092,1.768-8.111V9.574q0-.969-1.12-1.072H77.8l-1.451,6.351a2.2,2.2,0,0,1-2.269,1.162q-1.236,0-1.234-.932L74,9.626l-.031-.282A1.065,1.065,0,0,0,72.786,8.5Zm8.123,2.38a26.181,26.181,0,0,0-.817,3.846v.325a2.849,2.849,0,0,0,.139.843q.555,1.524,2.917,1.523a4.419,4.419,0,0,0,1.473-.273h.023l.031.029-.278,1a1.961,1.961,0,0,1-2.045,1.08H79.821a1.7,1.7,0,0,0-1.2.577,2.87,2.87,0,0,0-.362,1.078h.031l.031.03H82.19A4.35,4.35,0,0,0,83.9,20.5,3.682,3.682,0,0,0,85.7,18.609q.177-.5,2.269-10.034c0-.053-.2-.081-.594-.081a1.544,1.544,0,0,0-1.05.407H86.3a3.933,3.933,0,0,0-2.045-.407,3.8,3.8,0,0,0-3.735,2.388m1.528,1.028a1.939,1.939,0,0,1,2.131-1.731,4.168,4.168,0,0,1,.787.074.764.764,0,0,1,.625.813q0,.259-.656,3.121A1.853,1.853,0,0,1,83.1,15.7h-.486q-1.15,0-1.15-.865.047-.518.586-2.929m8.087-7.46L87.474,16.51v.17q.133,1.087,1.073,1.087h.478l.031-.03.9-4.008q.5-2.6.958-2.951.4-.628,1.883-.628,1.288,0,1.289.946-.062.585-1.134,5.354v.229q.123,1.087,1.072,1.087h.509l.718-3.239a26.222,26.222,0,0,0,.717-3.55v-.14a3.372,3.372,0,0,0-.147-.917q-.587-1.545-3.109-1.545h-.031a4.291,4.291,0,0,0-1.551.251l-.031-.022L91.75,5.6l-.061-.37a1.1,1.1,0,0,0-1.165-.776Zm6.429.347A2.085,2.085,0,0,0,95.911,6.2h2.754l.031.029Q96.66,15.29,96.389,16.7q0,.918,1.142,1.065l.509-.03L99.955,9.16a28.722,28.722,0,0,1,.687-2.957h1.442a1.524,1.524,0,0,0,1.134-.518,2.443,2.443,0,0,0,.448-1.206h-.031l-.023-.029H97.47a1.539,1.539,0,0,0-.9.347m6.457,4.252a3.953,3.953,0,0,0-1.79,2.2,34.146,34.146,0,0,0-.819,3.963,2.821,2.821,0,0,0,.324,1.324,2.535,2.535,0,0,0,2.285,1.236h.88a3.862,3.862,0,0,0,2.469-.9,4.409,4.409,0,0,0,1.2-1.715,29.772,29.772,0,0,0,.848-4.134,3.447,3.447,0,0,0-.147-.864,2.627,2.627,0,0,0-2.731-1.634l-.231.03-.209-.03a4.543,4.543,0,0,0-2.083.533m-.672,5.6a15.186,15.186,0,0,1,.911-3.542,1.921,1.921,0,0,1,1.79-.813h.2q1.3,0,1.3.754v.17a26.669,26.669,0,0,1-.617,2.981,1.921,1.921,0,0,1-2,1.827h-.494q-1.15,0-1.15-.873,0-.5.062-.5m8.71-8.511a8.065,8.065,0,0,0-1.02,3.143q-1.218,5.42-1.219,5.886v.318A2.54,2.54,0,0,0,109.3,16.8a2.964,2.964,0,0,0,2.084.969l1.019-.03h3.071c.056,0,.105-.209.147-.629v-.14l-.062-.347a1.224,1.224,0,0,0-1.25-.651h-2.562q-1.048,0-1.05-.917v-.06q1.528-7.223,1.737-7.69a1.928,1.928,0,0,1,1.937-1.078h3.665c.061,0,.113-.21.155-.629V5.278a1.264,1.264,0,0,0-1.343-.828h-2.176a4.049,4.049,0,0,0-3.611,1.685m7.372,4.814-1.528,6.759.061.06h3.79a3.828,3.828,0,0,0,1.975-.451h.023a1.118,1.118,0,0,0,1.034.451h.325q.733-3.025,2.059-9.243v-.03H122.44a3.954,3.954,0,0,0-4.006,2.454m1.736.592a1.75,1.75,0,0,1,1.822-1.272h1.945l-.942,4.229a2.019,2.019,0,0,1-2.207,1.524h-1.62q.532-2.559,1-4.481m7.592-3.025-.03.03q-1.7,7.587-1.76,8.067v.17a.641.641,0,0,0,.062.311,1.151,1.151,0,0,0,1.142.673h.355l.787-3.4a14.915,14.915,0,0,1,.826-3.209,1.687,1.687,0,0,1,1.319-.865,1.687,1.687,0,0,0,1.081-.621A2.131,2.131,0,0,0,131.9,8.6l-.062-.051h-1a3.821,3.821,0,0,0-1.759.421q-.271-.45-1.289-.451Zm5.385.939a4.742,4.742,0,0,0-1.119,1.641,27.85,27.85,0,0,0-.887,4.208,2.75,2.75,0,0,0,.208,1.05q.649,1.411,2.886,1.412h3.489c.052,0,.1-.187.147-.563v-.17q0-.9-1.126-1.02h-2.385l-.678-.06a.835.835,0,0,1-.68-.82v-.082l.231-1.132h4.106a1.633,1.633,0,0,0,1.359-.709,6.48,6.48,0,0,0,.47-2.145,2.68,2.68,0,0,0-.209-1.1,2.434,2.434,0,0,0-2.445-1.471h-.772a4.052,4.052,0,0,0-2.593.961m.741,1.811a1.848,1.848,0,0,1,1.853-1.02h.563l.209.029q.717,0,.825.961l-.178.932h-3.542Z",
    transform: "translate(2.423 1.332)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToughEnoughToCareLogo);
export default __webpack_public_path__ + "static/media/tough-enough-to-care-logo.776c1a6c2866c287a4686a3d4d739204.svg";
export { ForwardRef as ReactComponent };